<template>
  <!-- 在线支付查询 -->
  <div class="payQuery">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['订单管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-download"
          @click="exportData"
          v-if="buttonVisibility.export"
          >导出数据</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">支付方式：</label>
        <el-select
          placeholder="支付方式"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="searchForm.start"
          style="width: 200px; margin-right: 5px"
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="searchForm.end"
          style="width: 200px; margin-right: 5px"
          placeholder="选择结束日期"
        >
        </el-date-picker>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入订单号"
          v-model="searchForm.content"
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="seach"
          v-if="buttonVisibility.search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="orderNo"
        show-overflow-tooltip
        label="订单号"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="rq"
        show-overflow-tooltip
        label="日期"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="businessname"
        show-overflow-tooltip
        label="单位"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="generate"
        show-overflow-tooltip
        label="临时单号"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="thirdparty"
        show-overflow-tooltip
        label="交易号"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="postage"
        show-overflow-tooltip
        label="邮费"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="fee"
        show-overflow-tooltip
        label="金额"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="payType"
        show-overflow-tooltip
        label="方式"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="addtime"
        show-overflow-tooltip
        label="支付时间"
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "payQuery",
  data() {
    return {
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      //支付方式 开始时间 截至时间 单号
      searchForm: {
        status: "ALL",
        start: "",
        end: "",
        content: "",
      },
      options: [
        {
          value: "ALL",
          label: "全部",
        },
        {
          value: "微信",
          label: "微信",
        },
        {
          value: "支付宝",
          label: "支付宝",
        },
        {
          value: "对公支付",
          label: "对公支付",
        },
        {
          value: "扫码支付",
          label: "扫码支付",
        },
      ],
      /**表格数据 */
      //订单号	单位	临时单号	交易号	金额	方式	时间
      tableData: [
        {
          orderNum: "",
          unit: "",
          temporaryNum: "",
          money: "",
          payMode: "",
          time: "",
        },
      ],
    };
  },
  components: {},
  computed: {
    ...mapState(['buttonPermissions']),
    // 按钮权限
    buttonVisibility() {
      const buttonsLimit = this.buttonPermissions?.['在线支付查询'] || [] ;
      // console.log('在线支付查询buttonsLimit', buttonsLimit);
      return {
        export: buttonsLimit.includes('导出数据'),
        search: buttonsLimit.includes('搜索'),
      }
    }
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    seach() {
      this.getTableData(1);
    },
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "OrderPayInquire",
        startDate: this.searchForm.start,
        endDate: this.searchForm.end,
        strwhere: this.searchForm.content,
        payType: this.searchForm.status,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_OrderPay"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "rechargeorder/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    exportData() {
      // let startDate = this.searchForm.start
      // let endDate = this.searchForm.end
      // let payType = this.searchForm.status
      // let txtStrWhere = this.searchForm.content
      // let userId = window.localStorage.getItem('userId')
      // let entId = window.localStorage.getItem('entId')
      // window.location = this.baseUrl + "ToExcel/ToExcePayOrderList?startDate=" + startDate + "&endDate=" + endDate + "&payType=" + payType + "&strWhere=" + txtStrWhere + "&userId=" + userId + "&entId=" + entId

      let data = {
        type: "OrderPayInquire",
        userId: window.localStorage.getItem("userId"),
        entId: window.localStorage.getItem("entId"),
        startDate: this.searchForm.start,
        endDate: this.searchForm.end,
        strwhere: this.searchForm.content,
        payType: this.searchForm.status,
        PageIndex: 1,
        PageSize: 9999999,
      };
      let proc = "Proc_OrderPay";
      window.location.href =
        this.baseUrl +
        "Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name=在线支付订单";
    },
  },
};
</script>

<style scoped>
.payQuery {
  width: 100%;
  height: 100%;
}
</style>
